import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { getViewportHeight } from '@common';
import { UsersState, UsersStore } from '@store';

import { UIService } from '@services';
import { SearchService } from '../../../../+search/search.service';

@Component({
  selector: 'app-users-search-results',
  templateUrl: './users-search-results.component.html',
  styleUrls: ['./users-search-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersSearchResultsComponent {
  @Output() fetchNext = new EventEmitter();
  @Input() dataState$: Observable<UsersState>;
  @Input() searchParams;
  itemSize = 48;
  nextBatch = false;
  getViewportHeight = getViewportHeight;

  constructor(
    public searchService: SearchService,
    public uIService: UIService,
    private usersStore: UsersStore,
    private router: Router
  ) {}

  onFetchNext(next: { offset?: number; limit: number; cursor?: string }): void {
    this.usersStore.fetchMoreUsers(this.searchParams, next.limit, next.offset);
  }

  onNextBatchChange($event: boolean): void {
    this.fetchNext.emit();
    this.nextBatch = $event;
  }

  navigateTo(id: string): void {
    if (id) {
      this.router.navigate(['/users', id]);
    }
  }
}
